import React from 'react';
import { useNavigate } from "react-router-dom";
import PostRequest from '../../service/PostRequest';

const PricingCards = ({ packageDetails, purchaseRequired, customerName, customerEmail, subscriptionId, isSmallsize }) => {
  const navigate = useNavigate();

  const navigateToRegistrationPage = (planName) => {
    const queryParams = {
      plan: planName,
    };
    const queryString = new URLSearchParams(queryParams).toString();
    navigate(`/register?${queryString}`);
  };

  const purchasePackage = async () => {
    const data = {
      applicationId:"Boss",
      packageName: packageDetails.packageName,
      customerName: customerName,
      customerEmail: customerEmail,
      paymentInitiatedCountry:"uk",
      subscriptionId: subscriptionId,
      invoiceNeeded: true,
    };
    console.log("the registered data is", data);

    try {
      const response = await PostRequest('v1/store-management-service/view/manager/subscription/package', data, true);
      console.log(response);
      if (response === undefined) {
        console.log("Purchase API failed");
      } else {
        if (typeof response === 'string') {
          window.location.href = response;
        }
      }
    } catch (error) {
      console.error("purchase request failed:", error);
    }
  };

  return (
    <div className={`pricing-card-view ${isSmallsize ? 'xx-small-pricing-card' : ''} ${packageDetails.isDefault===true ? 'default' : ''}`}>
      {packageDetails.isDefault === true ? (
            <div className='recomended-package'>Recommended</div>
        ) : null}
      <div className="package-details-header">
      
        <div className="package-name">{packageDetails.packageName}</div>
        <br/> 

        <div className="package-purchase-action-text">
      
        <div className="price-tag">
        {packageDetails.price ? (
          <>
            {packageDetails.price}
            <span style={{ fontSize: '18px', color: '#0094DC' }}>/ Month</span>
          </>
        ) : null}
      </div>
        </div>
        <div className="package-tagline">{packageDetails.label}</div>
      </div>

      <div className="package-purchase-action-container">
      
        {purchaseRequired ? (
          <div className={`price-action-btn ${packageDetails.isDefault===true ? 'pckg-selected-btn' : ''}`} onClick={() => purchasePackage()}>Subscribe for {packageDetails.price} Monthly</div>
        ) : (
          <div className={`price-action-btn ${packageDetails.isDefault===true ? 'pckg-selected-btn' : ''}`} onClick={() => navigateToRegistrationPage(packageDetails.packageName)}>{packageDetails.action}</div>
        )}
      </div>

      <div className="package-purchase-action-text">
      {packageDetails.packageName} features includes
        </div>

      <div className="package-details-features">
      

        {packageDetails.features && packageDetails.features.map((detail, index) => (
          <div key={index} className="feature-block">
            <div className="feature-icon"></div>
            <div className="feature-name">{detail}</div>
          </div>
        ))}
      </div>
      
    </div>
  );
};

export default PricingCards;
